import { createFeatureSelector, createSelector, ActionReducerMap } from '@ngrx/store'
import * as fromLoader from './loader.reducer'
import { loaderFeatureKey } from './loader.reducer'

export interface RootState {
  loader: fromLoader.LoaderState
}

export const reducers: ActionReducerMap<RootState> = {
  loader: fromLoader.LoaderReducer,
}

export const selectLoaderState = createFeatureSelector<fromLoader.LoaderState>(loaderFeatureKey)

export const selectActive = createSelector(selectLoaderState, (state) => state.active)

export const selectActionsInProgress = createSelector(selectLoaderState, (state) => state.actionsInProgress)

export const selectIsLoading = createSelector(selectLoaderState, (state) => state.active > 0)

export const getIsLoading = (id: string | number | Array<string | number>) =>
  createSelector(selectActive, selectActionsInProgress, (active, actions) => {
    return id ? (Array.isArray(id) ? !!actions.find((item) => id.includes(item)) : actions.includes(id)) : active > 0
  })
